<script>
import Layout from '@layouts/main.vue'
import {
  documentMethods,
  fileMethods,
  fileComputed,
  authComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Failai',
  },

  components: { Layout },

  data() {
    return {
      title: '',
      description: '',
      form: {
        url: '',
      },
      errorMessage: null,
      failedField: null,
    }
  },

  computed: {
    ...authComputed,

    ...fileComputed,
  },

  created() {
    this.loadDocumentInfo()
  },

  methods: {
    ...documentMethods,

    ...fileMethods,

    loadDocumentInfo() {
      this.viewDocument(this.$route.params.id).then(
        ({ title, description }) => {
          this.title = title
          this.description = description
        },
      )
      this.fetchAllFiles(this.$route.params.id)
    },

    onFileChange(file) {
      this.createFile({ documentId: this.$route.params.id, file }).then(
        this.loadDocumentInfo,
      )
    },

    onSubmitUrl() {
      this.failedField = null
      this.createUrl({
        documentId: this.$route.params.id,
        url: this.form.url,
      })
        .then(() => {
          this.form.url = ''
          this.loadDocumentInfo()
        })
        .catch(() => {
          this.failedField = 'url'
        })
    },

    confirmFileDelete(id) {
      if (confirm('Ar tikrai norite ištrinti failą?')) {
        this.deleteFile({ documentId: this.$route.params.id, id }).then(
          this.loadDocumentInfo,
        )
      }
    },
  },
}
</script>

<template>
  <Layout>
    <base-page-title>
      <template v-slot:title>
        <div class="text-2xl font-bold">
          {{ title }}
        </div>
      </template>
      <template v-slot:actions>
        <div>
          <base-btn class="input" @click="$router.push({ name: 'documents' })">
            <font-awesome-icon :icon="['fas', 'undo']" class="mr-1" />
            Grįžti atgal
          </base-btn>
        </div>
      </template>
    </base-page-title>

    <div class="-mx-4 lg:-mx-8">
      <div class="overflow-x-auto">
        <table class="table-auto w-full">
          <thead v-if="files && files.length">
            <tr>
              <th class="text-left">Pavadinimas</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="file in files" :key="file.id">
              <td class="py-2">
                <div class="flex flex-column">
                  <div class="flex-grow">
                    <base-upload-link
                      v-if="file.file_path"
                      :filename="file.file_path"
                    >
                      {{ file.file_name }}
                    </base-upload-link>
                    <a v-else :href="file.url" target="_blank">
                      {{ file.url }}
                    </a>
                  </div>
                  <div v-if="currentUser.role !== 'volunteer'">
                    <base-btn
                      type="danger"
                      class="ml-2 px-2 py-1"
                      @click="confirmFileDelete(file.id)"
                    >
                      Pašalinti
                    </base-btn>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="border-none">
                <div class="flex flex-col lg:flex-row">
                  <div class="flex-1 bg-gray-100 rounded p-4">
                    <div class="mb-2 font-medium"> Naujas failas </div>
                    <input
                      id="file"
                      type="file"
                      @change="onFileChange($event.target.files[0])"
                    />
                  </div>
                  <div
                    class="flex items-center justify-center p-8 italic text-xs"
                  >
                    arba
                  </div>
                  <div class="flex-1 bg-gray-100 rounded p-4">
                    <form @submit.prevent="onSubmitUrl">
                      <base-label-input
                        v-model="form.url"
                        label="Naujas adresas (URL)"
                        type="text"
                        :error="failedField === 'url'"
                      />
                    </form>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </Layout>
</template>
